<template>
  <figure class="gfig">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="gfig__svg" v-html="svg"></div>

    <figcaption v-if="overview" class="gfig__legend">
      <span v-for="(label, i) in labels" :key="i" class="gfig__legend-item">
        <b>{{ i + 1 }}</b>{{ label }}
      </span>
    </figcaption>
    <figcaption v-else-if="caption" class="gfig__cap">{{ caption }}</figcaption>
  </figure>
</template>

<script>
/**
 * Envoltorio del plano de la ventana de Nukli. El dibujo en sí vive en
 * `figure.js`, porque las páginas estáticas que se prerenderizan para los
 * buscadores pintan exactamente el mismo SVG.
 */
import { renderFigureSvg } from './figure';
import { renderScreen } from './screens';

export default {
  name: 'GuideFigure',
  props: {
    /**
     * Mockup HTML de una pantalla concreta (`screens.js`). Tiene prioridad
     * sobre `zone`: cuando el paso ocurre en Ajustes o en un panel del rail, el
     * plano de la bandeja no sirve de nada.
     */
    screen: { type: String, default: '' },
    /** Elemento a resaltar dentro del mockup. */
    highlight: { type: String, default: '' },
    /** Idioma del contenido falso del mockup. */
    lang: { type: String, default: 'en' },
    /** Clave de ZONES a resaltar. Vacío = dibujo limpio, sin foco. */
    zone: { type: String, default: '' },
    /** Número del paso, para el globo sobre la zona. */
    step: { type: [Number, String], default: 0 },
    caption: { type: String, default: '' },
    /** Modo plano: etiqueta las cinco zonas principales a la vez. */
    overview: { type: Boolean, default: false },
    /** Rótulos del modo plano, en el idioma de la página. */
    labels: { type: Array, default: () => [] },
    alt: { type: String, default: 'Nukli' },
  },
  computed: {
    svg() {
      if (this.screen) {
        return renderScreen({
          screen: this.screen,
          highlight: this.highlight,
          step: Number(this.step) || 0,
          lang: this.lang,
        });
      }
      return renderFigureSvg({
        zone: this.zone,
        step: Number(this.step) || 0,
        overview: this.overview,
        alt: this.alt,
      });
    },
  },
};
</script>

<style scoped>
.gfig { margin: 0; }
.gfig__svg { display: block; }

.gfig__cap {
  margin-top: 12px;
  font-size: 1rem;
  line-height: 1.55;
  color: var(--lp-muted);
}
.gfig__legend {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 22px;
}
.gfig__legend-item {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 1.02rem;
  color: var(--lp-ink-2);
}
.gfig__legend-item b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--lp-accent);
  color: #fff;
  font-size: 0.85rem;
}
</style>
